import React from 'react';
import { IconProps } from './types';

const ArrowRect: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    width={size}
    height={size * 1.6}
    viewBox="0 0 6 10"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.38618 10L1.79137e-08 8.49779L3.22763 5L1.01335e-07 1.50221L1.38618 1.65301e-08L6 5L1.38618 10Z"
    />
  </svg>
);

export default ArrowRect;
